export default __webpack_public_path__ + "static/media/instagram.5ef3f425.svg";